var map = {
	"./noble01/礼物@2x.png": "9e92",
	"./noble02/礼物@2x.png": "522d",
	"./noble03/礼物@2x.png": "ee2d",
	"./noble04/礼物@2x.png": "c82d",
	"./noble05/礼物@2x.png": "c624"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3420";